export const isGamezClan = window.location.hostname.includes('gamezclan')
//  || window.location.hostname.includes('localhost')
 ? true : false


// WEBPACK FOOTER //
// ./src/constants/isGamezClan.js